import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { OpentokService } from "../_services/opentok.service";
import { Caption } from "../_models/models";
import Enumerable from "linq";
import { of } from "rxjs";
import { delay } from "rxjs/operators";
import { OrganizationService, StreamBoxService } from "../_services/generatedServices";
import { ConferenceRoomViewModel } from "../_models/generatedModels";
import { ActivatedRoute } from "@angular/router";
import { SettingsProvider } from "../_services/settingsProvider.service";

@Component({
  selector: 'bxl-captions-display',
  templateUrl: 'captions-display.component.html',
})
export class CaptionsDisplayComponent implements OnInit {
  initialized = false;
  private session: OT.Session;
  captions: Caption[] = [];
  strCaptions: string [] = [''];
  strCaptionsDisplay: string[] = [];
  private lastFinalCaption: string = '';
  private allFinalizedText: string = ''; // Track all text that's been finalized

  private lastInterimCaption: string = '';
  private captionDebounceTimer: any;


  currentIndex = 0;
  @ViewChild('card') private card: ElementRef;
  rooms: ConferenceRoomViewModel[];
  private conferenceSlug: string;
  public selectedRoom: number;
  fontSize: number = 20;
  private subscription: OT.Subscriber;


  constructor(private route: ActivatedRoute, public settingsProvider: SettingsProvider, private streamboxService: StreamBoxService, private openTokService: OpentokService, private organizationService: OrganizationService, private ref: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe((parentParam) => {
      this.conferenceSlug = parentParam.get('conferenceSlug');
      this.organizationService.getRoomsForConference(this.conferenceSlug).subscribe((result) => {
        this.rooms = Enumerable.from(result).where(x => x.channel != null).toArray();
        this.initialized = true;
      });
    });
  }

  public scrollToBottom(check: boolean): void {
    if (!this.card || !this.card.nativeElement) {
      return;
    }
    of(null)
      .pipe(delay(500))
      .subscribe((result) => {
        this.card.nativeElement?.scroll({
          top: this.card.nativeElement?.scrollHeight,
          left: 0,
          behavior: 'smooth',
        });
      });
  }

  public roomUpdated() {
    if (this.session) {
      this.session.off('streamCreated');
      this.session.unsubscribe(this.subscription);
      this.session.disconnect();
      this.session = null;
    }
    // Reset caption state when switching rooms
    this.strCaptions = [];
    this.strCaptionsDisplay = [];
    this.currentIndex = 0;
    this.lastFinalCaption = '';
    this.allFinalizedText = '';

    this.lastInterimCaption = '';
    if (this.captionDebounceTimer) {
      clearTimeout(this.captionDebounceTimer);
    }

    console.log('room updated to: ' + this.selectedRoom);

    this.streamboxService.getStreamboxForRoomId(this.selectedRoom).subscribe((result) => {
      console.log("LOading captions for channel: " + result.azureChannel);
      this.InitOpenTok(result.id);
    });
  }


  private InitOpenTok(streamboxId: number) {
    this.openTokService
      .initsessionForStreamBoxCaptions(streamboxId)
      .then((session: OT.Session) => {
        this.session = session;
        this.session.on('streamCreated', (event) => {
          console.log('here');
          console.log(event.stream.name);
          console.log(event.stream.connection.data);

          this.subscription = this.session.subscribe(event.stream, 'videoCanvas', {
            insertMode: 'append',
            subscribeToAudio: false,
            subscribeToVideo: false,
            preferredResolution: {
              width: 1280,
              height: 720
            },
            style: {nameDisplayMode: 'off'},
          });
          this.subscription.element.hidden = true;

          this.subscription.subscribeToCaptions(true);
          this.subscription.on('captionReceived', (event) => {
            console.log(`Caption received for stream ${event.streamId}`);
            console.log(`Caption text: ${event.caption}`);
            console.log(`Final text: ${event.isFinal}`);

            const captionText = event.caption?.trim() || '';

            // Skip empty captions
            if (!captionText) {
              return;
            }

            if (event.isFinal) {
              // Check if this exact caption was just added
              if (captionText === this.lastFinalCaption) {
                console.log('Skipping exact duplicate final caption');
                return;
              }

              // Check if this text is already contained in our finalized text
              // This catches the case where the service resends a block of sentences
              if (this.allFinalizedText.includes(captionText)) {
                console.log('Skipping caption - already in finalized text');
                return;
              }

              // Check if the new caption overlaps with recently finalized text
              // Sometimes the service sends "sentence A. sentence B." then later "sentence B. sentence C."
              const lastTwoSentences = this.strCaptions.slice(-2).join(' ');
              if (lastTwoSentences.length > 20 && captionText.includes(lastTwoSentences.substring(lastTwoSentences.length - 20))) {
                console.log('Skipping overlapping caption block');
                return;
              }

              // Add the final caption to the array
              this.strCaptions.push(captionText);
              this.lastFinalCaption = captionText;

              // Keep a running record of all finalized text (last 500 chars to avoid memory issues)
              this.allFinalizedText = (this.allFinalizedText + ' ' + captionText).slice(-500);

              // Keep only the last 5 final captions for display
              this.strCaptionsDisplay = this.strCaptions.slice(-5);

              this.scrollToBottom(true);
              this.ref.detectChanges();
            } else {
              // For non-final (interim) captions, show the last 4 final + current interim
              const lastFinalCaptions = this.strCaptions.slice(-4);
              this.strCaptionsDisplay = [...lastFinalCaptions, captionText];

              this.scrollToBottom(true);
              this.ref.detectChanges();
            }

          }, this)
        });

      }).then(() => this.openTokService.connect())
      .catch((err) => {
        console.error(err);
        alert('Unable to connect. Make sure you have updated the config.ts file with your OpenTok details.');
      });
  }



  public increaseFont() {
    this.fontSize += 5;
  }

  public decreaseFont() {
    this.fontSize -= 5;
  }


}
